import { useEffect } from "react";

// Canonical/authoritative production domain for SEO tags.
export const SITE_ORIGIN = "https://vynlworld.com";

/**
 * Keeps canonical + og:url + twitter:url + robots in sync per route.
 * @param {string} path  Absolute path e.g. "/", "/terms".
 * @param {{ noindex?: boolean }} opts
 */
export function useSeo(path = "/", opts = {}) {
  const { noindex = false } = opts;

  useEffect(() => {
    const url = SITE_ORIGIN + (path === "/" ? "/" : path);

    const setAttr = (id, attr, value) => {
      const el = document.getElementById(id);
      if (el) el.setAttribute(attr, value);
    };

    setAttr("canonical-link", "href", url);
    setAttr("og-url", "content", url);
    setAttr("twitter-url", "content", url);
    setAttr("robots-meta", "content", noindex ? "noindex, nofollow" : "index, follow");

    return () => {
      // Reset to indexable default on unmount so SPA nav never leaves noindex behind.
      setAttr("robots-meta", "content", "index, follow");
    };
  }, [path, noindex]);
}
